import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import { palette } from '@livable/saas-react-components';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  pageWrapper: {
    paddingTop: '32px'
  },
  method: {
    display: 'flex',
    alignItems: 'center'
  },
  methodName: {
    margin: '0 20px'
  },
  paperContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  primaryPaymentMethod: {
    marginRight: '10px'
  },
  actions: {
    display: 'flex',
    marginLeft: '40px',
    '& .modal-trigger': {
      margin: '0 10px'
    },
    [breakpointsFunc.breakpoints.down('md')]: {
      marginLeft: '0'
    }
  },
  accordionWrapper: {
    margin: '24px -40px -24px -40px'
  },
  accordion: {
    boxShadow: 'none',
    '&.Mui-expanded': {
      margin: '0'
    },
    '& .MuiAccordionSummary-root': {
      background: palette.gradients.white,
      flexDirection: 'row-reverse',
      minHeight: '84px',
      padding: '0 32px'
    },
    '& .MuiCollapse-root': {
      borderTop: "1px solid ".concat(palette.shades[300])
    }
  },
  accordionContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between'
  },
  accordionDetails: {
    padding: '24px 74px'
  }
}));
export default useStyles;